import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { notifications } from "@mantine/notifications";
import {
  reportReviewSettingsService,
  ReportReviewSettingsConflictError,
  UpdateReportReviewSettingsRequest,
} from "../../services/admin/reportReviewSettings.service";

export const REPORT_REVIEW_SETTINGS_QUERY_KEY = [
  "report-review-settings",
] as const;

export function useReportReviewSettings(enabled = true) {
  return useQuery({
    queryKey: REPORT_REVIEW_SETTINGS_QUERY_KEY,
    queryFn: reportReviewSettingsService.get,
    enabled,
  });
}

export function useUpdateReportReviewSettings() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (request: UpdateReportReviewSettingsRequest) =>
      reportReviewSettingsService.update(request),
    onSuccess: (result) => {
      queryClient.setQueryData(REPORT_REVIEW_SETTINGS_QUERY_KEY, result.matrix);
      notifications.show({
        title: "Review requirements updated",
        message: result.changed
          ? "The saved requirements apply to the next matching sign-out."
          : "Those requirements were already current.",
        color: "green",
        autoClose: 4000,
      });
    },
    onError: (error) => {
      void queryClient.invalidateQueries({
        queryKey: REPORT_REVIEW_SETTINGS_QUERY_KEY,
      });
      notifications.show({
        title: "Requirements not changed",
        message:
          typeof ReportReviewSettingsConflictError === "function" &&
          error instanceof ReportReviewSettingsConflictError
            ? error.message
            : "The requirements could not be saved. Check your connection and try again.",
        color: "red",
        autoClose: 5000,
      });
    },
  });
}
